import { createIndexableMetas } from './metadata/indexable-metas';
import { createBasicMetas } from './metadata/basic-metas';
import { createOpenGraphMetas } from './metadata/open-graph-metas';
import { createTwitterMetas } from './metadata/twitter-metas';
import { createFacebookMetas } from './metadata/facebook-metas';
import { createThemeMetas } from './metadata/theme-metas';
import { createMsAppMetas } from './metadata/msapp-metas';

const SITE_NAME = 'Spotahome';

function pageMetadataBuilder({
  basic = {},
  og = {},
  twitter = {},
  fb = {},
  ms = {},
  city,
  cityName
}) {
  const indexableMetas = createIndexableMetas({
    indexable: basic.indexable
  });

  const translatedTitle = basic.title?.replace(
    `landingpage.label.${city}`,
    cityName
  );
  const translatedDescription = basic.description?.replace(
    `landingpage.label.${city}`,
    cityName
  );

  const basicMetas = createBasicMetas({
    title: translatedTitle,
    description: translatedDescription
  });

  const openGraphMetas = createOpenGraphMetas({
    title: translatedTitle,
    description: translatedDescription,
    type: og.type,
    imageUrl: og.imageUrl,
    siteName: SITE_NAME,
    url: og.url,
    locale: og.locale
  });

  const twitterMetas = createTwitterMetas({
    card: twitter.card,
    title: translatedTitle,
    description: translatedDescription,
    imageSrc: twitter.imageUrl,
    url: twitter.url
  });

  const facebookMetas = createFacebookMetas({
    appId: fb.appId,
    title: translatedTitle,
    description: translatedDescription,
    imageUrl: og.imageUrl,
    siteName: SITE_NAME,
    url: og.url,
    locale: og.locale
  });

  const themeMetas = createThemeMetas();
  const msAppMetas = createMsAppMetas(ms);

  return [
    ...indexableMetas,
    ...basicMetas,
    ...openGraphMetas,
    ...twitterMetas,
    ...facebookMetas,
    ...themeMetas,
    ...msAppMetas
  ];
}

export default pageMetadataBuilder;
